<template>
  <div class="guide column">
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7291 5.13538C19.2296 5.13538 19.6354 4.72963 19.6354 4.22913C19.6354 3.72862 19.2296 3.32288 18.7291 3.32288C18.2286 3.32288 17.8229 3.72862 17.8229 4.22913C17.8229 4.72963 18.2286 5.13538 18.7291 5.13538Z"
        class="bot"
        fill-opacity="0.2"
      />
      <path
        d="M10.2708 5.13538C10.7713 5.13538 11.177 4.72963 11.177 4.22913C11.177 3.72862 10.7713 3.32288 10.2708 3.32288C9.77024 3.32288 9.3645 3.72862 9.3645 4.22913C9.3645 4.72963 9.77024 5.13538 10.2708 5.13538Z"
        class="bot"
        fill-opacity="0.2"
      />
      <path
        d="M4.22913 17.2187C3.98885 17.2184 3.7585 17.1228 3.5886 16.9529C3.4187 16.783 3.32314 16.5527 3.32288 16.3124V13.8958C3.32314 13.6555 3.4187 13.4251 3.5886 13.2552C3.7585 13.0853 3.98885 12.9898 4.22913 12.9895H5.13538V17.2187H4.22913Z"
        class="bot"
        fill-opacity="0.2"
      />
      <path
        d="M23.8645 17.2187V12.9895H24.7708C25.011 12.9898 25.2414 13.0853 25.4113 13.2552C25.5812 13.4251 25.6767 13.6555 25.677 13.8958V16.3124C25.6767 16.5527 25.5812 16.783 25.4113 16.9529C25.2414 17.1228 25.011 17.2184 24.7708 17.2187H23.8645Z"
        class="bot"
        fill-opacity="0.2"
      />
      <g filter="url(#filter0_i)">
        <path
          d="M11.7812 22.9583C11.7816 22.9186 11.774 22.8791 11.759 22.8423C11.744 22.8054 11.7217 22.772 11.6936 22.7438C11.6655 22.7157 11.632 22.6935 11.5952 22.6784C11.5583 22.6634 11.5189 22.6558 11.4791 22.6562H7.85408C7.29346 22.6556 6.75599 22.4326 6.35956 22.0362C5.96314 21.6398 5.74015 21.1023 5.7395 20.5417V10.2708C5.74015 9.71021 5.96314 9.17273 6.35956 8.77631C6.75599 8.37989 7.29346 8.1569 7.85408 8.15625H21.1457C21.7064 8.15693 22.2438 8.37993 22.6402 8.77635C23.0366 9.17276 23.2597 9.71022 23.2603 10.2708V20.5417C23.2597 21.1023 23.0366 21.6397 22.6402 22.0362C22.2438 22.4326 21.7064 22.6556 21.1457 22.6562H16.3124C16.2537 22.657 16.1962 22.6737 16.1463 22.7046L11.7812 25.4337V22.9583ZM10.2708 17.5197C10.2025 17.5199 10.1364 17.5433 10.0831 17.5858C10.0297 17.6284 9.99234 17.6878 9.97696 17.7542C9.96158 17.8207 9.96909 17.8904 9.99829 17.9521C10.0275 18.0138 10.0767 18.0638 10.1378 18.094C11.5015 18.7353 12.9932 19.0578 14.4999 19.0373C16.0068 19.0578 17.4986 18.7352 18.8624 18.0939C18.9234 18.0635 18.9723 18.0135 19.0014 17.9518C19.0304 17.8902 19.0378 17.8206 19.0224 17.7543C19.007 17.6879 18.9696 17.6287 18.9164 17.5862C18.8632 17.5436 18.7972 17.5203 18.7291 17.5199C18.683 17.52 18.6376 17.531 18.5966 17.5521C17.3157 18.1518 15.9153 18.4526 14.5011 18.4318C13.0867 18.4525 11.686 18.1519 10.4045 17.5527C10.3632 17.5312 10.3173 17.5199 10.2708 17.5197ZM17.5208 11.7812C17.761 11.7815 17.9914 11.8771 18.1613 12.047C18.3312 12.2169 18.4267 12.4472 18.427 12.6875C18.427 12.7676 18.4588 12.8445 18.5155 12.9011C18.5721 12.9578 18.649 12.9896 18.7291 12.9896C18.8092 12.9896 18.886 12.9578 18.9427 12.9011C18.9993 12.8445 19.0312 12.7676 19.0312 12.6875C19.0312 12.2869 18.872 11.9027 18.5888 11.6195C18.3055 11.3362 17.9213 11.1771 17.5208 11.1771C17.1202 11.1771 16.736 11.3362 16.4527 11.6195C16.1695 11.9027 16.0103 12.2869 16.0103 12.6875C16.0103 12.7676 16.0422 12.8445 16.0988 12.9011C16.1555 12.9578 16.2323 12.9896 16.3124 12.9896C16.3925 12.9896 16.4694 12.9578 16.526 12.9011C16.5827 12.8445 16.6145 12.7676 16.6145 12.6875C16.6148 12.4472 16.7103 12.2169 16.8802 12.047C17.0501 11.8771 17.2805 11.7815 17.5208 11.7812ZM11.4791 11.7812C11.7194 11.7815 11.9497 11.8771 12.1196 12.047C12.2895 12.2169 12.3851 12.4472 12.3853 12.6875C12.3853 12.7676 12.4172 12.8445 12.4738 12.9011C12.5305 12.9578 12.6073 12.9896 12.6874 12.9896C12.7675 12.9896 12.8444 12.9578 12.901 12.9011C12.9577 12.8445 12.9895 12.7676 12.9895 12.6875C12.9895 12.2869 12.8304 11.9027 12.5471 11.6195C12.2639 11.3362 11.8797 11.1771 11.4791 11.1771C11.0785 11.1771 10.6943 11.3362 10.4111 11.6195C10.1278 11.9027 9.96867 12.2869 9.96867 12.6875C9.96867 12.7676 10.0005 12.8445 10.0571 12.9011C10.1138 12.9578 10.1906 12.9896 10.2708 12.9896C10.3509 12.9896 10.4277 12.9578 10.4844 12.9011C10.541 12.8445 10.5728 12.7676 10.5728 12.6875C10.5731 12.4472 10.6687 12.2169 10.8386 12.047C11.0085 11.8771 11.2388 11.7815 11.4791 11.7812Z"
          class="bot"
          fill-opacity="0.3"
        />
      </g>
      <path
        d="M10.2708 13.2917C10.3502 13.2919 10.4289 13.2765 10.5023 13.2462C10.5758 13.216 10.6425 13.1715 10.6986 13.1153C10.7548 13.0592 10.7993 12.9925 10.8295 12.919C10.8598 12.8456 10.8752 12.7669 10.875 12.6875C10.875 12.5273 10.9386 12.3736 11.0519 12.2603C11.1652 12.147 11.3189 12.0833 11.4791 12.0833C11.6394 12.0833 11.793 12.147 11.9063 12.2603C12.0196 12.3736 12.0833 12.5273 12.0833 12.6875C12.0833 12.8477 12.1469 13.0014 12.2603 13.1147C12.3736 13.228 12.5272 13.2917 12.6875 13.2917C12.8477 13.2917 13.0014 13.228 13.1147 13.1147C13.228 13.0014 13.2916 12.8477 13.2916 12.6875C13.2916 12.2068 13.1007 11.7458 12.7608 11.4059C12.4209 11.066 11.9598 10.875 11.4791 10.875C10.9984 10.875 10.5374 11.066 10.1975 11.4059C9.85759 11.7458 9.66663 12.2068 9.66663 12.6875C9.66635 12.7669 9.68179 12.8456 9.71206 12.919C9.74232 12.9925 9.78681 13.0592 9.84297 13.1153C9.89913 13.1715 9.96584 13.216 10.0393 13.2462C10.1127 13.2765 10.1914 13.2919 10.2708 13.2917Z"
        class="bot"
      />
      <path
        d="M18.4602 17.2821C16.2037 18.4119 12.7992 18.4119 10.5396 17.2821C10.3962 17.2108 10.2303 17.1994 10.0785 17.2504C9.92668 17.3014 9.80133 17.4106 9.73002 17.554C9.65872 17.6974 9.6473 17.8633 9.69829 18.0151C9.74927 18.1669 9.85849 18.2923 10.0019 18.3636C11.4074 19.0271 12.9458 19.3608 14.4999 19.3393C16.054 19.3608 17.5924 19.0271 18.9979 18.3636C19.1413 18.2923 19.2506 18.1669 19.3015 18.0151C19.3525 17.8633 19.3411 17.6974 19.2698 17.554C19.1985 17.4106 19.0732 17.3014 18.9213 17.2504C18.7695 17.1994 18.6036 17.2108 18.4602 17.2821Z"
        class="bot"
      />
      <path
        d="M24.7708 12.0833H24.1666V10.2708C24.1663 9.46976 23.848 8.70157 23.2815 8.13511C22.7151 7.56866 21.9469 7.2503 21.1458 7.25001H19.3333V5.92991C19.7364 5.78739 20.0761 5.50695 20.2925 5.13816C20.5088 4.76937 20.5878 4.33598 20.5155 3.91457C20.4432 3.49317 20.2243 3.11089 19.8974 2.83531C19.5705 2.55972 19.1567 2.40857 18.7291 2.40857C18.3016 2.40857 17.8878 2.55972 17.5609 2.83531C17.234 3.11089 17.015 3.49317 16.9427 3.91457C16.8704 4.33598 16.9494 4.76937 17.1658 5.13816C17.3821 5.50695 17.7219 5.78739 18.125 5.92991V7.25001H10.875V5.92991C11.2781 5.78739 11.6178 5.50695 11.8342 5.13816C12.0505 4.76937 12.1295 4.33598 12.0572 3.91457C11.9849 3.49317 11.7659 3.11089 11.439 2.83531C11.1122 2.55972 10.6984 2.40857 10.2708 2.40857C9.84323 2.40857 9.42944 2.55972 9.10254 2.83531C8.77564 3.11089 8.5567 3.49317 8.4844 3.91457C8.41209 4.33598 8.49109 4.76937 8.70743 5.13816C8.92377 5.50695 9.26352 5.78739 9.66663 5.92991V7.25001H7.85413C7.0532 7.25081 6.2853 7.56934 5.71896 8.13568C5.15261 8.70202 4.83409 9.46992 4.83329 10.2708V12.0833H4.22913C3.74854 12.0837 3.28775 12.2748 2.94792 12.6146C2.60809 12.9545 2.41701 13.4153 2.41663 13.8958V16.3125C2.41701 16.7931 2.60809 17.2539 2.94792 17.5937C3.28775 17.9335 3.74854 18.1246 4.22913 18.125H4.83329V20.5417C4.83409 21.3426 5.15261 22.1105 5.71896 22.6768C6.2853 23.2432 7.0532 23.5617 7.85413 23.5625H10.875V25.9792C10.8752 26.0869 10.9042 26.1927 10.959 26.2855C11.0138 26.3783 11.0923 26.4548 11.1865 26.5071C11.2807 26.5595 11.3871 26.5857 11.4949 26.5832C11.6026 26.5807 11.7077 26.5494 11.7993 26.4927L16.4846 23.5625H21.1458C21.9469 23.5622 22.7151 23.2439 23.2815 22.6774C23.848 22.111 24.1663 21.3428 24.1666 20.5417V18.125H24.7708C25.2514 18.1246 25.7122 17.9335 26.052 17.5937C26.3918 17.2539 26.5829 16.7931 26.5833 16.3125V13.8958C26.5829 13.4153 26.3918 12.9545 26.052 12.6146C25.7122 12.2748 25.2514 12.0837 24.7708 12.0833ZM4.83329 16.9167H4.22913C4.06904 16.9162 3.91564 16.8524 3.80244 16.7392C3.68923 16.626 3.62543 16.4726 3.62496 16.3125V13.8958C3.62543 13.7358 3.68923 13.5824 3.80244 13.4692C3.91564 13.356 4.06904 13.2922 4.22913 13.2917H4.83329V16.9167ZM18.7291 3.62501C18.8486 3.62501 18.9654 3.66045 19.0648 3.72684C19.1641 3.79322 19.2416 3.88758 19.2873 3.99798C19.333 4.10837 19.345 4.22985 19.3217 4.34705C19.2984 4.46425 19.2408 4.5719 19.1563 4.65639C19.0718 4.74089 18.9642 4.79843 18.847 4.82174C18.7298 4.84505 18.6083 4.83309 18.4979 4.78736C18.3875 4.74163 18.2932 4.66419 18.2268 4.56484C18.1604 4.46548 18.125 4.34867 18.125 4.22918C18.1254 4.06909 18.1892 3.91569 18.3024 3.80249C18.4156 3.68929 18.569 3.62548 18.7291 3.62501ZM10.2708 3.62501C10.3903 3.62501 10.5071 3.66045 10.6065 3.72684C10.7058 3.79322 10.7832 3.88758 10.829 3.99798C10.8747 4.10837 10.8867 4.22985 10.8634 4.34705C10.84 4.46425 10.7825 4.5719 10.698 4.65639C10.6135 4.74089 10.5059 4.79843 10.3887 4.82174C10.2715 4.84505 10.15 4.83309 10.0396 4.78736C9.92919 4.74163 9.83483 4.66419 9.76845 4.56484C9.70206 4.46548 9.66663 4.34867 9.66663 4.22918C9.6671 4.06909 9.7309 3.91569 9.8441 3.80249C9.9573 3.68929 10.1107 3.62548 10.2708 3.62501ZM22.9583 20.5417C22.9579 21.0223 22.7668 21.4831 22.427 21.8229C22.0872 22.1627 21.6264 22.3538 21.1458 22.3542H16.3125C16.1995 22.3549 16.0888 22.3862 15.9923 22.4448L12.0833 24.8887V22.9583C12.0836 22.8789 12.0681 22.8002 12.0379 22.7268C12.0076 22.6534 11.9631 22.5867 11.907 22.5305C11.8508 22.4744 11.7841 22.4299 11.7107 22.3996C11.6372 22.3693 11.5585 22.3539 11.4791 22.3542H7.85413C7.37354 22.3538 6.91275 22.1627 6.57292 21.8229C6.23309 21.4831 6.04201 21.0223 6.04163 20.5417V10.2708C6.04201 9.79026 6.23309 9.32947 6.57292 8.98964C6.91275 8.64981 7.37354 8.45873 7.85413 8.45835H21.1458C21.6264 8.45873 22.0872 8.64981 22.427 8.98964C22.7668 9.32947 22.9579 9.79026 22.9583 10.2708V20.5417ZM25.375 16.3125C25.3745 16.4726 25.3107 16.626 25.1975 16.7392C25.0843 16.8524 24.9309 16.9162 24.7708 16.9167H24.1666V13.2917H24.7708C24.9309 13.2922 25.0843 13.356 25.1975 13.4692C25.3107 13.5824 25.3745 13.7358 25.375 13.8958V16.3125Z"
        class="bot"
      />
      <path
        d="M17.5208 10.875C17.0402 10.8754 16.5794 11.0665 16.2395 11.4063C15.8997 11.7461 15.7086 12.2069 15.7083 12.6875C15.7083 12.8477 15.7719 13.0014 15.8852 13.1147C15.9985 13.228 16.1522 13.2917 16.3124 13.2917C16.4727 13.2917 16.6263 13.228 16.7396 13.1147C16.8529 13.0014 16.9166 12.8477 16.9166 12.6875C16.9166 12.5273 16.9802 12.3736 17.0935 12.2603C17.2068 12.147 17.3605 12.0833 17.5208 12.0833C17.681 12.0833 17.8347 12.147 17.948 12.2603C18.0613 12.3736 18.1249 12.5273 18.1249 12.6875C18.1249 12.8477 18.1886 13.0014 18.3019 13.1147C18.4152 13.228 18.5689 13.2917 18.7291 13.2917C18.8893 13.2917 19.043 13.228 19.1563 13.1147C19.2696 13.0014 19.3333 12.8477 19.3333 12.6875C19.3329 12.2069 19.1418 11.7461 18.802 11.4063C18.4621 11.0665 18.0013 10.8754 17.5208 10.875Z"
        class="bot"
      />
      <defs>
        <filter
          id="filter0_i"
          x="5.7395"
          y="8.15625"
          width="17.5208"
          height="21.2774"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.92549 0 0 0 0 0.243137 0 0 0 0 0.458824 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
      </defs>
    </svg>
    <div class="frame-1" v-if="pass['1']">
      <div class="title">Olá!</div>
      <div class="text">
        {{
          modal.theme.text.guide ||
          "Sou " +
            user.genero_bot_km +
            " " +
            user.nome_bot_km +
            " e vou guiar você na sua primeira visita ao atendimento " +
            user.cliente +
            "!"
        }}
      </div>
    </div>
    <div class="frame-2" v-if="pass['2']">
      <div class="title">Fale comigo!</div>
      <div class="text">
        Aqui em cima você consegue solicitar um atendimento comigo, para que eu
        possa identificar seu problema.
      </div>
    </div>
    <div class="frame-3" v-if="pass['3']">
      <div class="title">Veja suas solicitações!</div>
      <div class="text">
        Sempre que falar com nossos especialistas, poderá acompanhar todo o caso
        por aqui.
      </div>
    </div>
    <div class="frame-4" v-if="pass['4']">
      <div class="title">Dúvidas?</div>
      <div class="text">
        Você sempre pode passar por esse tutorial de novo! Basta clicar no botão
        ”Como Funciona?”
      </div>
    </div>
    <div class="frame-5" v-if="pass['5']">
      <div class="title">Confira seus chamados!</div>
      <div class="text">
        Agora você consegue acompanhar o atendimento por esse card na home!
      </div>
    </div>
    <div class="frame-6" v-if="pass['6']">
      <div class="title">Use o filtro!</div>
      <div class="text">
        Visualize todas as suas solicitações, ou filtre por abertas e fechadas.
      </div>
    </div>
    <div class="row">
      <Button layout="remote-continue" class="button-continue" @click="next()"
        >OK!</Button
      >
      <Button
        layout="remote-skip"
        class="button-skip"
        @click="
          modal.show = false;
          resetBlur();
          modal.guideClass = 'guide-modal-1';
          pass.n = 1;
        "
        >PULAR</Button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Button from "@/components/Button";

export default {
  props: { modal: Object },
  components: { Button },
  data() {
    return {
      pass: {
        n: 1,
        1: true,
        2: false,
        3: false,
        4: false,
        5: false,
      },
    };
  },
  methods: {
    resetBlur() {
      let container = document.getElementById("ns");
      container.classList.remove("blur-1");
      container.classList.remove("blur-2");
      container.classList.remove("blur-3");
      container.classList.remove("blur-4");
      container.classList.remove("blur-5");
      container.classList.remove("blur-6");
    },
    next() {
      let pass = {
        n: this.pass.n + 1,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
      };
      this.pass = pass;
      let container = document.getElementById("ns");
      this.resetBlur();

      if (this.pass.n == 1) {
        this.modal.guideClass = "guide-modal-1";
        container.classList.add("blur-1");
      }
      if (this.pass.n == 2) {
        this.modal.guideClass = "guide-modal-2";
        container.classList.add("blur-2");
      }
      if (this.pass.n == 3) {
        if (!document.getElementById("card-list")) {
          this.modal.guideClass = "guide-modal-3";
          container.classList.add("blur-3");
        } else {
          this.next();
          return;
        }
      }

      if (this.pass.n == 4) {
        this.modal.guideClass = "guide-modal-4";
        let help = document.getElementById("help");

        document
          .querySelectorAll(".background")[0]
          .style.setProperty(
            "background-position",
            "-" + (help.offsetLeft - 37) + "px -600px"
          );

        container.classList.add("blur-4");
      }

      if (this.pass.n == 5) {
        if (document.getElementById("card-list")) {
          this.modal.guideClass = "guide-modal-5";
          container.classList.add("blur-5");
        } else {
          this.next();
          return;
        }
      }

      if (this.pass.n == 6) {
        let filters = document.getElementById("filters");
        if (filters) {
          this.modal.guideClass = "guide-modal-6";
          document
            .querySelectorAll(".background")[0]
            .style.setProperty(
              "background-position",
              "-" + filters.offsetLeft - 150 + "px -200px"
            );

          let modal = document.querySelector(".modal-box");
          modal.style.left = filters.offsetLeft - 50 + "px ";
          container.classList.add("blur-6");
        } else {
          this.next();
          return;
        }
      }

      if (this.pass.n == 7) {
        this.modal.show = false;
        this.modal.guideClass = "guide-modal-1";
      }

      this.pass[pass.n] = true;
    },
  },
  mounted() {
    document.getElementById("ns").classList.add("blur-1");
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.guide {
  width: 220px;
  padding: 25px 34px;
  padding-bottom: 15px;

  @media (max-width: $small) {
    width: auto;
  }

  .logo {
    margin-bottom: 24px;
  }
  .title {
    font-weight: 600;
    margin-bottom: 8px;
    margin-top: 12px;
    font-size: 24px;
    line-height: 20px;
  }
  .text {
    font-size: 15px;
    line-height: 20px;
    font-weight: 300;
    margin-bottom: 23px;
  }
  .pager {
    margin: 20px 0px;
  }
  .frame {
    overflow: hidden;
  }

  &-2 {
    position: absolute;
    left: 0px;
    top: 0px;
  }
}
</style>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;

.HeaderClientRemote {
  .background {
    @media (max-width: $small) {
      background-color: transparent !important;
    }
  }
}

.guide-modal-1 {
  .modal-box {
    left: 42.5%;
    top: 90px !important;
  }
}
.guide-modal-2 {
  .modal-box {
    left: 225px;
    top: 90px !important;

    @media (max-width: $small) {
      top: 120px !important;
    }
  }
  .background {
    @media (min-width: $small) {
      background: url("../../../assets/img/remote/guide2.svg") !important;
      background-repeat: no-repeat;
      background-size: auto !important;
      position: absolute !important;
      height: 110vh !important;
      margin-top: -74px;
    }
  }
}
.guide-modal-3 {
  .modal-box {
    right: 42.5%;
  }
  .background {
    @media (min-width: $small) {
      background: url("../../../assets/img/remote/guide3.svg") center top !important;
      background-repeat: no-repeat;
      position: absolute !important;
      height: 110vh !important;
      margin-top: -74px;
    }
  }
}
.guide-modal-4 {
  .modal-box {
    left: 65%;
    top: 90px !important;

    @media (max-width: $small) {
      top: 50px !important;
    }
  }
  .background {
    @media (min-width: $small) {
      background-image: url("../../../assets/img/remote/guide3.svg") !important;
      background-color: transparent !important;
      background-repeat: no-repeat;
      position: absolute !important;
      height: 110vh !important;
      margin-top: -74px;
    }
  }
}
.guide-modal-5 {
  .modal-box {
    left: 400px;
    top: 90px !important;
    @media (max-width: $small) {
      top: 0px !important;
    }
  }
  .background {
    @media (min-width: $small) {
      background: url("../../../assets/img/remote/guide3.svg") -2450px -120px !important;
      background-repeat: no-repeat;
      position: absolute !important;
      height: 110vh !important;
      margin-top: -74px;
    }
  }
}
.guide-modal-6 {
  .modal-box {
    top: 200px !important;
    @media (max-width: $small) {
      margin-left: 50px;
    }
  }
  .background {
    @media (min-width: $small) {
      background-color: transparent !important;
      background-image: url("../../../assets/img/remote/guide6.svg") !important;
      background-repeat: no-repeat;
      position: absolute !important;
      height: 110vh !important;
      margin-top: -74px;
    }
  }
}

@media (max-width: $small) {
  .blur-1 {
    .menu,
    .userTab,
    .content,
    .filters,
    #enjoy,
    .filters {
      filter: blur(5px);
    }
  }
  .blur-2 {
    .menu,
    .userTab,
    .content,
    .filters {
      filter: blur(5px);
    }
  }
  .blur-3 {
    .menu,
    .userTab,
    #enjoy,
    .filters {
      filter: blur(5px);
    }
  }
  .blur-4 {
    .logo,
    .notifyRemote,
    .userTab,
    .content,
    #enjoy,
    .filters {
      filter: blur(5px);
    }
  }
  .blur-5 {
    .menu,
    .userTab,
    .filters,
    #enjoy {
      filter: blur(5px);
    }
  }

  .blur-6 {
    .menu,
    .userTab,
    .content,
    #enjoy {
      filter: blur(5px);
    }
  }
}
</style>